import { XMarkIcon } from '@heroicons/react/20/solid'

import { getFilterIndicator } from '@/lib/tableHelpers'

export default function ColumnFilterHeader({ label, hasFilter, onOpenFilter, onClearFilter }) {
	return (
		<div className="inline-flex items-center gap-1">
			<span className="font-semibold text-gray-700">{label}</span>
			<button
				type="button"
				className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
				onClick={onOpenFilter}
				title="Filtruj kolumne">
				{getFilterIndicator(hasFilter)}
			</button>
			{hasFilter ? (
				<button
					type="button"
					className="p-1 text-gray-400 hover:text-red-600 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
					onClick={onClearFilter}
					title="Wyczysc filtr">
					<XMarkIcon className="h-4 w-4" aria-hidden="true" />
				</button>
			) : null}
		</div>
	)
}
